// Define the structure of the API object
interface ApiObject {
  name: string;
  addTimingLogs: boolean;
  getEndpoint: () => string;
}
// Define the union type for API names
type ApisNames = keyof typeof APIS_ENDPOINT;

// Define the type for the createApiObject function
type CreateApiObject = (name: ApisNames, addTimingLogs?: boolean) => ApiObject;

// Define the type for APIS_ENDPOINT dynamically
type ApisEndpoint = Record<string, ApiObject>;

const createApiObject: CreateApiObject = (name, addTimingLogs = false) => ({
  name,
  addTimingLogs,
  getEndpoint() {
    return `c/${this.name}`;
  },
});

export const APIS_ENDPOINT: ApisEndpoint = {
  getCreatorAuthorizations: createApiObject(
    "getCreatorConfigAndAuthorizations",
    true
  ),
  getCreatorConfig: createApiObject("getCreatorConfigAndAuthorizations", true),
  getCreatorData: createApiObject("fetchCreatorDetailsShop", true),
  getExploreBannerDetails: createApiObject("getExploreBannerDetails", true),
  getStorePostsData: createApiObject("fetchCreatorShopPosts", true),
};
